"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTranslationFlag = useTranslationFlag;
var _react = require("react");
var _constants = require("../utils/constants");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// Manages the per-message "flagged language" selection used to attach a
// translated sub-bubble to outgoing messages. `languageList` can be
// overridden per app/deployment; defaults to the three languages web already
// ships (en/es/cat).
function useTranslationFlag() {
  let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$languageList = _ref.languageList,
    languageList = _ref$languageList === void 0 ? _constants.DEFAULT_LANGUAGE_LIST : _ref$languageList,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? "en" : _ref$defaultValue;
  const _useState = (0, _react.useState)(() => languageList.find(item => item.value === defaultValue) || languageList[0] || null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedLanguage = _useState2[0],
    setSelectedLanguage = _useState2[1];
  const selectLanguage = (0, _react.useCallback)(value => {
    const found = languageList.find(item => item.value === value);
    if (found) setSelectedLanguage(found);
  }, [languageList]);
  const flaggedLanguage = (0, _react.useMemo)(() => {
    var _selectedLanguage$val;
    return (_selectedLanguage$val = selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.value) !== null && _selectedLanguage$val !== void 0 ? _selectedLanguage$val : defaultValue;
  }, [selectedLanguage, defaultValue]);
  return {
    languageList,
    selectedLanguage,
    flaggedLanguage,
    selectLanguage
  };
}